import { Injectable } from '@angular/core';
import { ColorVariant } from '@psei/ng/api';
import { DialogService, LegacyDialogConfig } from '@psei/ng/dialog';
import { BehaviorSubject, combineLatest, fromEvent, Observable, of, Subject, Subscription } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class FormChangeService {

  isDirty$: Observable<boolean>
  isPreventPopup$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isDrawerOpen: boolean = false;
  closeSubscription: Subscription;

  constructor(private readonly dialogBoxService: DialogService) {
  }

  setupDirtyWatch(isDirtyFromComponent$: Observable<boolean>): void {
    this.isDrawerOpen = true;
    this.isDirty$ = isDirtyFromComponent$;
    this.closeSubscription = combineLatest([
      fromEvent(window, 'beforeunload') as Observable<BeforeUnloadEvent>,
      this.isDirty$,
      this.isPreventPopup$]
    )
      .subscribe(([event, isDirty, isPreventPopup]) => {
        if (isPreventPopup) {
          event.returnValue = false;
          return
        }
        if (isDirty) {
          event.returnValue = false
        }
      })
  }

  onConfirm = () => {
    this.isDrawerOpen = false;
    this.clearIsDirty();
  }

  onCancel = () => {
    this.dialogBoxService.legacy.closeCurrent();
  }

  executeDialog(onConfirm: () => void = this.onConfirm, onCancel: () => void = this.onCancel): Subject<boolean> {
    const handled$ = new Subject<boolean>();
    this.dialogBoxService.legacy.open(FormChangeService.generateDialog(() => {
      onConfirm();
      this.dialogBoxService.legacy.closeCurrent();
      handled$.next(true);
    }, () => {
      onCancel();
      this.dialogBoxService.legacy.closeCurrent();
      handled$.next(false);
    }));
    return handled$;
  }

  private static generateDialog(onConfirm: () => void, onCancel: () => void): LegacyDialogConfig<string> {
    return {
      title: $localize`:@@form-change.title:Czy chcesz zamknąć formularz?`,
      text: $localize`:@@form-change.text:Opuszczenie strony spowoduje utratę wszystkich niezapisanych danych.\n
        Czy na pewno chcesz zamknąć formularz?`,
      value: 'value',
      buttons: [
        {
          label: $localize`:@@common.no:Nie`,
          colorVariant: ColorVariant.Secondary,
          onSelect: onCancel,
        },
        {
          label: $localize`:@@common.yes:Tak`,
          colorVariant: ColorVariant.Negative,
          onSelect: onConfirm
        }
      ]
    };
  }

  clearIsDirty(): void {
    this.closeSubscription?.unsubscribe();
    this.isDirty$ = of(false);
  }
}
